import { CHANGE_THEME_TO_DARK, CHANGE_THEME_TO_LIGHT } from '../actions/basics_action/themeActions';

const initialState = {
    className: 'theme-light',
};

export const Theme = (state = initialState, action) => {
    switch (action.type) {
    case CHANGE_THEME_TO_DARK:
        return { className: 'theme-dark' };
    case CHANGE_THEME_TO_LIGHT:
        return { className: 'theme-light' };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/App/redux/reducers/theme_reducers.js